import { Alert } from "antd";
import Marquee from "react-fast-marquee";
import { observer } from "mobx-react";
import { useMobxStores } from "../../stores/stores";
import { useLocation } from "react-router-dom";
import { MobileView } from "react-device-detect";
import { CloseOutlined } from "@ant-design/icons";
const MessageBanner = () => {
  const { errorStore } = useMobxStores();
  const location = useLocation();

  return (
    <>
      {errorStore.items_request !== "" && (
        <Alert
          banner
          message={
            <Marquee pauseOnHover gradient={false}>
              {errorStore.items_request}
            </Marquee>
          }
        />
      )}
      {errorStore.better_experience !== "" && location.pathname === "/" && (
        <MobileView>
          <Alert
            style={{ fontSize: "14px" }}
            banner
            message={errorStore.better_experience}
            onClose={() => errorStore.clearBetterExperience()}
            closeIcon={<CloseOutlined />}
          />
        </MobileView>
      )}
    </>
  );
};

export default observer(MessageBanner);
